export const KOT_STATUS_FLOW = ["New", "Preparing", "Ready", "Served"];

export const KOT_STATUS_META = {
  New: {
    label: "Sent to kitchen",
    short: "Sent",
    badge: "bg-slate-100 text-slate-700 border-slate-200",
    section: "bg-slate-50 border-slate-200",
  },
  Preparing: {
    label: "Preparing",
    short: "Prep",
    badge: "bg-orange-100 text-orange-800 border-orange-200",
    section: "bg-orange-50 border-orange-200",
  },
  Ready: {
    label: "Ready to serve",
    short: "Ready",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-300",
    section: "bg-emerald-50 border-emerald-300",
    pulse: true,
  },
  Served: {
    label: "Served",
    short: "Served",
    badge: "bg-slate-100 text-slate-500 border-slate-200",
    section: "bg-white border-slate-200",
  },
};

function lineAmountForQty(line, qty) {
  const fullQty = Number(line.qty ?? 0);
  const rate = Number(line.rate ?? 0);
  if (fullQty > 0) {
    return (Number(line.amount ?? 0) * qty) / fullQty;
  }
  return rate * qty;
}

function emptyStatusQty() {
  return { New: 0, Preparing: 0, Ready: 0, Served: 0 };
}

/** Split bill lines into pending cart vs kitchen status groups. */
export function categorizeWaiterBillLines(lines = []) {
  const pending = [];
  const kitchen = {
    New: [],
    Preparing: [],
    Ready: [],
    Served: [],
  };

  for (const line of lines) {
    const isKot = line.is_kot !== false;
    const pendingQty = Number(
      line.kot_pending_qty ?? Math.max(0, Number(line.qty ?? 0) - Number(line.kot_sent_qty ?? 0)),
    );

    if (!isKot || pendingQty > 0) {
      pending.push({
        ...line,
        qty: isKot ? pendingQty : Number(line.qty ?? 0),
        amount: isKot ? lineAmountForQty(line, pendingQty) : Number(line.amount ?? 0),
      });
    }

    const statusQty = { ...emptyStatusQty(), ...(line.kot_status_qty || {}) };
    for (const status of KOT_STATUS_FLOW) {
      const qty = Number(statusQty[status] ?? 0);
      if (qty <= 0) continue;
      kitchen[status].push({
        ...line,
        qty,
        amount: lineAmountForQty(line, qty),
        kot_kitchen_status: status,
      });
    }
  }

  const hasKitchenActivity = KOT_STATUS_FLOW.some((s) => kitchen[s].length > 0);

  return { pending, kitchen, hasKitchenActivity };
}

/** @deprecated use categorizeWaiterBillLines */
export function splitWaiterBillLines(lines = []) {
  const { pending, kitchen } = categorizeWaiterBillLines(lines);
  const inKitchen = [...kitchen.New, ...kitchen.Preparing, ...kitchen.Ready, ...kitchen.Served];
  return { pending, inKitchen, kitchen };
}

export function waiterHasPendingKot(lines = []) {
  return lines.some((line) => {
    if (line.is_kot === false) return false;
    return Number(line.kot_pending_qty ?? line.qty ?? 0) > 0;
  });
}

export function billHasKitchenSession(lines = [], kotSummary = null) {
  if (kotSummary?.in_kitchen_qty > 0 || kotSummary?.served_qty > 0) return true;
  return lines.some((line) => Number(line.kot_sent_qty ?? 0) > 0);
}

export function kotSummaryFromBill(bill) {
  return bill?.kot_summary ?? null;
}
